import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/AuthContext";
import { ThemeProvider } from "@/ThemeContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Documents from "@/pages/Documents";
import CalendarPage from "@/pages/CalendarPage";
import CompanyProfile from "@/pages/CompanyProfile";
import Installations from "@/pages/Installations";
import InstallationDetail from "@/pages/InstallationDetail";
import Obligations from "@/pages/Obligations";
import ObligationDetail from "@/pages/ObligationDetail";
import Compliance from "@/pages/Compliance";
import DocumentDetail from "@/pages/DocumentDetail";
import Catalogs from "@/pages/Catalogs";
import AuditLog from "@/pages/AuditLog";
import SuperAdmin from "@/pages/SuperAdmin";
import Users from "@/pages/Users";
import Manual from "@/pages/Manual";
import TarjetaInformativa from "@/pages/TarjetaInformativa";
import Organizations from "@/pages/Organizations";
import OrganizationDetail from "@/pages/OrganizationDetail";
import "@/App.css";

const Protected = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-500">Cargando...</div>;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors theme="system" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/documentos" element={<Documents />} />
              <Route path="/documentos/:id" element={<DocumentDetail />} />
              <Route path="/cumplimiento" element={<Compliance />} />
              <Route path="/reportes/tarjeta-informativa" element={<TarjetaInformativa />} />
              <Route path="/instalaciones" element={<Installations />} />
              <Route path="/instalaciones/:id" element={<InstallationDetail />} />
              <Route path="/obligaciones" element={<Obligations />} />
              <Route path="/obligaciones/:id" element={<ObligationDetail />} />
              <Route path="/calendario" element={<CalendarPage />} />
              <Route path="/perfil-empresa" element={<CompanyProfile />} />
              <Route path="/usuarios" element={<Protected roles={["super_admin","admin"]}><Users /></Protected>} />
              <Route path="/super-admin" element={<Protected roles={["super_admin"]}><SuperAdmin /></Protected>} />
              <Route path="/organizations" element={<Protected roles={["super_admin"]}><Organizations /></Protected>} />
              <Route path="/organizations/:id" element={<Protected roles={["super_admin"]}><OrganizationDetail /></Protected>} />
              <Route path="/catalogos" element={<Protected roles={["super_admin"]}><Catalogs /></Protected>} />
              <Route path="/auditoria" element={<AuditLog />} />
              <Route path="/manual" element={<Manual />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
